import { createRoofLevel, createRoofAndParapet } from "@project-rouge/rg-three";
import { getActiveBuildings } from "./index183.js";
const pipeAddRoofAndParapet = ([parent, { buildingIds, aggProps }]) => {
  const dataset = aggProps.dataset;
  const buildings = getActiveBuildings(parent, aggProps);
  for (const building of buildings) {
    if (buildingIds && !buildingIds.includes(building.uuid))
      continue;
    const roofLevels = createRoofLevel(building, dataset.id);
    createRoofAndParapet({
      building,
      roofLevels,
      parapetModId: dataset.modulousIds.parapetId,
      roofModId: dataset.modulousIds.roofId,
      facadeModId: dataset.modulousIds.facadeId,
      rvDataList: dataset.rvData
    });
  }
  return [parent, void 0];
};
export {
  pipeAddRoofAndParapet
};
//# sourceMappingURL=index96.js.map
